import {IWorkspaceMembers} from "../../models/interfaces/workspaceMembers.interface.ts";
import {IWorkspaceMemberDto} from "../../models/interfaces/dtos/workspaceMembers.dto.interface.ts";

export const transformWorkspaceMembersDtoToWorkspaceMembers = (membersDto: IWorkspaceMemberDto[]): IWorkspaceMembers => {
  const transformed: IWorkspaceMembers = {};

  membersDto.forEach((memberDto: IWorkspaceMemberDto) => {
    const {_id, firstName, lastName, imageSasLink} = memberDto;
    transformed[_id] = {userId: _id, firstName, lastName, imageSasLink};
  });

  return transformed;
}